module.exports = __webpack_public_path__ + "img/nt55-00-80-1.asm.84ddc847.jpg";